export default __webpack_public_path__ + "static/media/desert.19d78865.jpg";